import { render } from "./Lists.vue?vue&type=template&id=0f351f96&scoped=true"
import script from "./Lists.vue?vue&type=script&lang=js"
export * from "./Lists.vue?vue&type=script&lang=js"

import "./Lists.vue?vue&type=style&index=0&id=0f351f96&scoped=scoped&lang=css"
import "./Lists.vue?vue&type=style&index=1&id=0f351f96&lang=css"

import exportComponent from "D:\\CODE\\clpgaAppDevnew\\clpga_html\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f351f96"]])

export default __exports__